var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"two-container"},[_c('div',{staticClass:"little-title2"},[_c('div',[_vm._v(_vm._s(_vm.$theme ? "加入我们" : "JOIN US"))])]),_c('vue-seamless-scroll',{staticClass:"tjwt-pie-right",attrs:{"data":_vm.joinUsList,"classOption":{
      step: 2,
      autoPlay: true,
      limitMoveNum: 5,
      direction: 2,
      hoverStop: false,
    }}},[_c('div',{staticClass:"con"},_vm._l((_vm.joinUsList),function(item,ind){return _c('div',{key:ind + 'sx',staticClass:"one-img"},[_c('img',{attrs:{"src":item.img,"alt":""}})])}),0)]),_c('div',{staticClass:"text-2"},[_vm._v(_vm._s(_vm.$theme ? "独木难支大厦，众志可成城郭" : ""))]),_c('div',{staticClass:"text-3"},[_vm._v("The power of unity is unstoppable")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }